import * as Yup from 'yup'

export const downloadReportdata = () => ({
    report_name: "",
    datetype:"",
    transtype:"",
    from_date: "",
    to_date: "",
    Trans_Type: "",
    Location_CD: "",
    MUL_DEALER_CD: "",
})

export const reportSchema = Yup.object().shape({
    report_name: Yup.string()
        .required('Report Options Required'),
    from_date: Yup.string()
        .required('From Date Required'),
    to_date: Yup.string()
        .required('To Date Required'),


})

export const reconciliationSchema = Yup.object().shape({
    report_name: Yup.string()
        .required('Report Options Required'),
    from_date: Yup.string()
        .required('From Date Required'),
    to_date: Yup.string()
        .required('To Date Required'),
    Trans_Type: Yup.string()
        .required('Trance Type Required'),
    Location_CD: Yup.string()
        .required('Location Required'),
    MUL_DEALER_CD: Yup.string()
        .required('Outlet Required'),

})